import React from "react";
import { ModalClose } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalSecondaryButton, ModalPrimaryButton } from "../..";

import "./styles.css";

export default function CancelPaymentModal(props) {
  const canceledClicked = evt => {
    props.data.CancelClicked();
}
  return (
    <CustomModal className="cancel-payment-modal" id="CancelPaymentModal" title="Cancel Payment?">
      <CustomModalContent>
        <p className="text-center">By canceling this payment, you may still have an amount due in the current payment period. Are you sure you want to cancel?</p>
      </CustomModalContent>
      <CustomModalFooter>
        <ModalPrimaryButton text="Cancel Payment" id="CancelPaymentModal" onClick={canceledClicked}/>
        <ModalClose id="CancelBalanceTransferModal">
          <ModalSecondaryButton text="Back" />
        </ModalClose>
      </CustomModalFooter>
    </CustomModal>
  )
}
